import { useContext } from "react";
import {  ConfiguratorContext } from "../context";
import useFinanciadoData from './useFinanciadoData';

const useAccessoriesData = () => {

  const [state, setState] = useContext(ConfiguratorContext);
  const { resetFinanciado } = useFinanciadoData();

  //Getters
  const getAccessories = () => state.accessories.data ? state.accessories.data : [];
  const getAddedAccessories = () => state.accessories.added ? state.accessories.added : [];
  const getFilteredAccessories = () => state.accessories.filtered ? state.accessories.filtered : [];
  const getSelectedFilter = () => state.accessories.selectedFilter ? state.accessories.selectedFilter : [];
  const getSelectedAccessory = () => state.accessories.selected ? state.accessories.selected : null;
  const getCategories = () => state.accessories.categories ? state.accessories.categories : [];
  const getIgnoreAccessories = () => state.accessories.ignore ? state.accessories.ignore.value : true;
  const getTotalPriceAccesories = () => state.accessories.totalPrice ? state.accessories.totalPrice : null;
  
  //Setters
  const setAccessories = accessories => {
    setState(prevState => ({
      ...prevState,
      accessories: {
        ...prevState.accessories,
        data: accessories,
      }
    }))
  }

  const setFilteredAccessories = accessories => {
    setState(prevState => ({
      ...prevState,
      accessories: {
        ...prevState.accessories,
        filtered: accessories,
      }
    }))
  }

  const setSelectedFilter = filter => {
    setState(prevState => ({
      ...prevState,
      accessories: {
        ...prevState.accessories,
        selectedFilter: filter,
      }
    }))
  }

  const setSelectedAccessory = accessory => {
    setState(prevState => ({
      ...prevState,
      accessories: {
        ...prevState.accessories,
        selected: accessory,
      }
    }))
  }

  const setCategories = categories => {
    setState(prevState => ({
      ...prevState,
      accessories: {
        ...prevState.accessories,
        categories,
      }
    }))
  }

  const setIgnoreAccessories = ignore => {
    setState(prevState => ({
      ...prevState,
      accessories: {
        ...prevState.accessories,
        ignore: {value: ignore}
      }
    }))
  }

  const setTotalPrice = accessories => {
    let total = 0;

    if (accessories.length) {
      total = accessories.map(item => item.price || 0);
      total = total.reduce((previusValue, currentValue) => previusValue + currentValue);
    }

    setState(prevState => ({
      ...prevState,
      accessories: {
        ...prevState.accessories,
        totalPrice: total
      },
      summary: {
        ...prevState.summary,
        accessories: total,
      }
    }))
  }


  //Methods
  const checkAddedAccessory = accessory => {
    let addedAccessories = [...state.accessories.added];
    let accessories = [...state.accessories.data];
    if (accessory.is_added) {
      addedAccessories = addedAccessories.filter(item => item.id !== accessory.id);
    }
    else {
      addedAccessories.push(accessory);
    }
    accessories.forEach(elem => {
      if (elem.id === accessory.id) elem.is_added = !elem.is_added;
    })
    setState(prevState => ({
      ...prevState,
      accessories: {
        ...prevState.accessories,
        data: accessories,
        added: addedAccessories,
      }
    }))

    setTotalPrice(addedAccessories);
    resetFinanciado();
    
  };

  return {
    getAccessories,
    getAddedAccessories,
    getFilteredAccessories,
    getSelectedFilter,
    getSelectedAccessory,
    getCategories,
    getIgnoreAccessories,
    getTotalPriceAccesories,
    setAccessories,
    setFilteredAccessories,
    setSelectedFilter,
    setSelectedAccessory,
    setCategories,
    setIgnoreAccessories,
    checkAddedAccessory
  }

}


export default useAccessoriesData;
